<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M28.2426 31.0711C25.8995 34.9763 22.1005 34.9763 19.7574 31.0711C17.4142 27.1658 17.4142 20.8342 19.7574 16.9289C22.1005 13.0237 25.8995 13.0237 28.2426 16.9289M16 21H24M16 27H24M42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6C33.9411 6 42 14.0589 42 24Z"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
